import { useQuery } from "@tanstack/react-query";
import visitApi from "../../api/visitApi";

export const useGetUserVisit = () => {
    return useQuery({
        queryKey: ["user-visit"],
        queryFn: () => visitApi.countVisit(),
    });
};
